import { Box, BoxProps, ColorOptions, Loader, ModBox, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useFocusEffect, useNavigation } from '@react-navigation/core'
import React, { useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import ActionsMenu from '../../components/ActionMenu/ActionsMenu'
import { Filters } from '../../components/FiltersWeb'
import { filterTypes } from '../../components/FiltersWeb/types'
import { ModalAlertView } from '../../components/ModalAlertView'
import { NewTable } from '../../components/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { filtersData } from '../../utils'
import { getCustomColumnWidth, makerHeaderTitles } from '../../utils/constants'

const Footer = ({ setShowAlertInfo }: any) => {
  const { claimTask, getRowsSelected, userName } = useStores((store) => ({
    claimTask: store.claimTask,
    getRowsSelected: store.getRowsSelected,
    userName: store.user.name,
  }))
  const [claimTaskApi, claimTaskHandler] = useLazyApiData(claimTask)

  useEffect(() => {
    if (claimTaskHandler.state === 'fulfilled') {
      setShowAlertInfo(true)
    }
  }, [claimTaskHandler.state, setShowAlertInfo])

  const onSubmit = () => {
    claimTaskApi(userName, getRowsSelected())
  }
  return (
    <Box {...styles.footer}>
      <ButtonNew onPress={onSubmit} title={'+ Claim'} height={40} width={94} color={'PRIMARY'} />
    </Box>
  )
}

const Header = ({ fetchDataOnChange, filterVisible, setFilterVisible, filterApplied }: any) => {
  return (
    <Box {...styles.header}>
      <ModBox w={'100%'}>
        <Text title={'Maker Application Queue'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ActionsMenu
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          showSearch={true}
          enableFilter
          showCalendar
          defaultPage={1}
          type="maker"
          filterApplied={filterApplied}
        />
      </ModBox>
    </Box>
  )
}
const Maker = () => {
  const {
    fetchMakerList,
    updateSelectedRowIndex,
    getRowsSelected,
    currentPage,
    getMakerList,
    updateAllRowsSelection,
    checkSelected,
    selectedFilteredData,
    updateFilters,
    makerListlength,
    setSideMenuRefresh,
    saveState,
    resetState,
    restoreFiltersToDefaults,
    setSearchFilterBy,
    resetFeePkgId,
    resetCheckerApplicationStatus,
  } = useStores((store) => ({
    fetchMakerList: store.fetchMakerList,
    updateSelectedRowIndex: store.updateSelectedRowIndex,
    getRowsSelected: store.getRowsSelected,
    currentPage: store.pagination.number,
    getMakerList: store.getMakerList,
    updateAllRowsSelection: store.updateAllRowsSelection,
    checkSelected: store.filter.checkSelected,
    selectedFilteredData: store.filter.getFilterData,
    updateFilters: store.filter.updateFilters,
    selectedDateInfo: store.selectedDateInfo,
    pagination: store.pagination,
    makerListlength: store.makerList.length,
    setSideMenuRefresh: store.setSideMenuRefresh,
    saveState: store.filter.saveState,
    resetState: store.filter.resetState,
    restoreFiltersToDefaults: store.filter.restoreFiltersToDefaults,
    applicationStatusLength: store.filter.applicationStatus.length,
    setSearchFilterBy: store.onboarding.setSearchFilterBy,
    resetFeePkgId: store.onboarding.resetFeePkgId,
    resetCheckerApplicationStatus: store.resetCheckerApplicationStatus,
  }))

  const navigation = useNavigation()
  const [listData, setListData] = useState<any>([])
  const [isLoading, setLoading] = useState(false)
  const [showClaim, setShowClaim] = useState(false)
  const [showAlertInfo, setShowAlertInfo] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)

  const [lazyFetchMakerListList, { state }] = useLazyApiData(fetchMakerList)

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      const list = getMakerList()
      setListData(list)
      setLoading(false)
    }
  }, [getMakerList, state, makerListlength])

  useFocusEffect(
    React.useCallback(() => {
      setLoading(true)
      lazyFetchMakerListList()
      setSideMenuRefresh(true)
      setSearchFilterBy('Entity ID')
      updateFilters('applicationStatus', 'ALL')
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  )

  const onPress = (item: any) => {
    setSearchFilterBy('Entity ID')
    resetFeePkgId()
    resetCheckerApplicationStatus()
    if (item?.applicationStatus === 'Error') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: { data: item, from: 'MAKER_QUEUE', isApprovedByChecker: true },
          },
        ],
      })
    } else {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: {
              data: JSON.parse(JSON.stringify(item)),
              from: 'MAKER_QUEUE',
              isApprovedByChecker: false,
              showApproveReject: false,
            },
          },
        ],
      })
    }
    setSideMenuRefresh(true)
  }

  const onItemChecked = (isChecked: boolean, index: any, rowData: any) => {
    updateSelectedRowIndex(currentPage - 1, index, rowData, isChecked)
    const rowsChecked = getRowsSelected(currentPage - 1)
    setShowClaim(rowsChecked.length > 0)
  }

  const { width, height } = useWindowDimensions()

  const fetchDataOnChange = () => {
    console.count('===> fetchDataOnChange')
    setLoading(true)
    lazyFetchMakerListList()
  }

  const handleAllCheckedChange = (isChecked: boolean) => {
    console.log('===> handleAllCheckedChange', isChecked)
    updateAllRowsSelection(currentPage, isChecked)
    const list = getMakerList()
    setListData(list)
    setShowClaim(isChecked)
  }

  const onFilterPress = () => {
    setFilterVisible(false)
    resetState()
  }

  const applyFilter = () => {
    fetchDataOnChange()
    setFilterVisible(false)
  }

  const navigateToMyQueue = () => {
    // navigation.reset({
    //   index: 0,
    //   routes: [{ name: 'checkerMyQueue' }],
    // })
  }

  const handleFilterVisibility = (visible: boolean) => {
    setFilterVisible(visible)
    if (visible) {
      saveState()
    }
  }

  const restoreFilterDefaults = () => {
    restoreFiltersToDefaults()
  }

  if (isLoading) {
    return <Loader />
  }
  return (
    <Box {...styles.container}>
      <Header
        fetchDataOnChange={fetchDataOnChange}
        filterVisible={filterVisible}
        setFilterVisible={handleFilterVisibility}
        filterApplied={
          selectedFilteredData?.applicationStatus?.length > 0 &&
          (selectedFilteredData?.applicationStatus?.includes('Completed') ||
            selectedFilteredData?.applicationStatus?.includes('Rejected') ||
            selectedFilteredData?.applicationStatus?.includes('Error') ||
            selectedFilteredData?.applicationStatus?.includes('Pending For Approval'))
        }
      />
      <ModBox padding={16} show={!filterVisible} minHeight={height <= 720 ? 600 : undefined}>
        <NewTable
          data={listData}
          rowHeight={48}
          headerHeight={64}
          height={544}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={makerHeaderTitles}
          onRowClick={onPress}
          onCheckChange={onItemChecked}
          getIsAllSelected={handleAllCheckedChange}
          freezeColumn={'check'}
          freezeColumnWidth={50}
        />
      </ModBox>
      <ModBox show={filterVisible}>
        <Filters
          onPress={onFilterPress}
          selectedFilteredData={selectedFilteredData}
          updateFilters={updateFilters}
          filterData={[filtersData]}
          checkSelected={checkSelected}
          apply={applyFilter}
          selectedValue={selectedFilteredData?.applicationStatus}
          mode={filterTypes.applicationStatus}
          restoreDefaults={restoreFilterDefaults}
        />
      </ModBox>
      <ModBox show={false}>
        <Footer setShowAlertInfo={setShowAlertInfo} />
      </ModBox>
      <ModalAlertView
        message="Selected items are added to 'My Queue'."
        show={showAlertInfo}
        showHeader={false}
        title={''}
        buttonTitle={'Go to my queue'}
        cancelTitle={"I'll Check Later"}
        onDismiss={() => setShowAlertInfo(false)}
        onPress={() => [navigateToMyQueue(), setShowAlertInfo(false)]}
        onCancel={() => setShowAlertInfo(false)}
        positiveButtonColor={'PRIMARY'}
        cancelButtonColor={'WHITE'}
      />
    </Box>
  )
}

export const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    minHeight: 720,
  } as BoxProps,
  header: {
    flexDirection: 'row',
    p: 16,
    h: 100,
    w: '100%',
    marginBottom: 16,
  } as BoxProps,
  footer: {
    p: 12,
    direction: 'row',
    justify: 'flex-end',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
  } as BoxProps,
}
export default Maker
